'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _web3Eth = require('web3-eth');

var _web3Eth2 = _interopRequireDefault(_web3Eth);

var _fetch = require('web3-provider-engine/dist/es5/subproviders/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _filters = require('web3-provider-engine/dist/es5/subproviders/filters');

var _filters2 = _interopRequireDefault(_filters);

var _sanitizer = require('web3-provider-engine/dist/es5/subproviders/sanitizer');

var _sanitizer2 = _interopRequireDefault(_sanitizer);

var _fixture = require('web3-provider-engine/dist/es5/subproviders/fixture');

var _fixture2 = _interopRequireDefault(_fixture);

var _inflightCache = require('web3-provider-engine/dist/es5/subproviders/inflight-cache');

var _inflightCache2 = _interopRequireDefault(_inflightCache);

var _index = require('web3-provider-engine/dist/es5/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStaticWeb3Engine = function getStaticWeb3Engine(rpcUrl) {
  return new _web3Eth2.default(function () {
    var engine = new _index2.default({ pollingInterval: 10000 });

    // static results
    engine.addProvider(new _fixture2.default({
      web3_clientVersion: 'ProviderEngine/v0.0.0/javascript',
      net_listening: true,
      eth_hashrate: '0x00',
      eth_mining: false,
      eth_subscribe: false
    }));
    engine.addProvider(new _sanitizer2.default());
    engine.addProvider(new _filters2.default());
    engine.addProvider(new _inflightCache2.default());

    engine.addProvider(new _fetch2.default({ rpcUrl: rpcUrl }));

    engine.start();
    return engine;
  }());
};

exports.default = getStaticWeb3Engine;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/staticWeb3Engine.js
// module id = 708
// module chunks = 0